// @flow

import * as React from "react";

import SectionHeader from "../molecules/SectionHeader";
import Image from "../atoms/Image";
import TextButton from "../atoms/TextButton";

type PropsType = {
    icons: any[],
    description?: string,
    title?: string,
};

const IconRow = (props: PropsType): React.Node => {
    return (
        <div className="icon-row">
            <SectionHeader
                sectionName="icon-row"
                title={props.title}
                description={props.description}
            />
            <div className="row">
                {props.icons.map((icon, tileIndex): React.Node => {
                    return (
                        <div
                            key={tileIndex}
                            className="col-xs-6 col-md-3 icon-row__icon"
                        >
                            <div className="icon-row__icon__image">
                                <Image
                                    src={icon.image.url}
                                    alt={icon.title}
                                    aspectRatio="1:1"
                                />
                            </div>
                            <h3 className="icon-row__icon__title">
                                {icon.title}
                            </h3>
                            <p className="icon-row__icon__description">
                                {icon.description}
                            </p>
                            <TextButton
                                className="icon-row__icon__cta"
                                to={icon.cta.url}
                            >
                                {icon.cta.title}
                            </TextButton>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

IconRow.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default IconRow;
